import React, { ChangeEvent, useState } from 'react';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import { BasicAuth } from '../../common/interfaces';
import AuthDataService from '../../common/services/AuthDataService';

interface Props {
  onSuccess: (credentials: BasicAuth) => void;
}

/**
 * @description Auth form.
 * @param {Props} props
 * @return {JSX.Element}
 */
const AuthForm = (props: Props): JSX.Element => {
  const [data, setData] = useState<BasicAuth>({ user: '', pass: '' });
  const [validated, setValidated] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [busy, setBusy] = useState<boolean>(false);

  const onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    const newData = { ...data };
    newData[event.target.name] = event.target.value;
    setData(newData);
  };

  const onFormSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
  ): Promise<void> => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const valid = form.checkValidity();

    // mark the form as having its validity checked
    setValidated(true);

    if (!valid) {
      console.log('not valid');
      return;
    }
    //
    setBusy(true);
    setErrorMessage('');
    try {
      // AuthDataService.setAuth(data);
      await AuthDataService.post(data);
      setBusy(false);
      props.onSuccess(data);
    } catch (err) {
      console.error('.', err, data);
      setErrorMessage('Invalid credentials provided.');
      setBusy(false);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <Form onSubmit={onFormSubmit}>
          <Form.Group className="mb-3" controlId="userInput">
            <Form.Label>User name</Form.Label>
            <Form.Control
              type="text"
              placeholder="jsmith"
              value={data.user}
              name={'user'}
              required={true}
              onChange={onChangeInput}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="passInput">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={data.pass}
              name={'pass'}
              required={true}
              onChange={onChangeInput}
            />
          </Form.Group>
          <Button variant="primary" type="submit" disabled={busy}>
            Sign in
          </Button>
          {errorMessage ? (
            <Alert variant={'danger'}>{errorMessage}</Alert>
          ) : null}
        </Form>
      </Container>
    </React.Fragment>
  );
};

export default AuthForm;
